import { useContext, useEffect, useState } from "react";
import { MyContext } from "../MyContext";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import helpers from "../Helpers";
import axios from "axios";
import logo from '../images/logo.png';

function Login(){
    const { setAuth, setIsAuthenticated } = useContext(MyContext);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [userLogin, setUserLogin] = useState({
        email: '',
        senha: ''
    });

    const initLogin = () => {
        const user = localStorage.getItem('user');

        if(user){
            setUserLogin((prev) => ({...prev, email: user}));
        }
    };

    const handleSubmitLogin = async(e) => {
        e.preventDefault();
        let alertForm;

        if(userLogin.email === ''){
            alertForm = {
                title: "Informe o login do usuário",
                icon: 'warning',
            };
            helpers.toastAlert(alertForm);
            return;
        }

        if(userLogin.senha === ''){
            alertForm = {
                title: "Informe a senha do usuário",
                icon: 'warning',
            };
            helpers.toastAlert(alertForm);
            return;
        }

        const base_url = `${urlApi}/login2`;

        try {
            let response = await axios.post(base_url, userLogin, {
                headers: { 
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            let data = response.data;

            if (data.status && data.status !== 200) {
                alertForm = {
                    title: `Falhou !!! ${data.message}`,
                    icon: 'error',
                };
                return helpers.toastAlert(alertForm);
            }

            if(data.user?.ativo !== 'L'){
                alertForm = {
                    title: `Falhou !!! ${data.message}`,
                    icon: 'error',
                };
                return helpers.toastAlert(alertForm);
            }

            localStorage.clear();
            localStorage.setItem('logged', 'true');
            localStorage.setItem('userAuth', JSON.stringify(data.user));

            setIsAuthenticated(true);
        } catch (error) {
            console.error('Erro na requisição de login:', error);

            setAuth(null);
        }
    };

    useEffect(()=>{
        initLogin();
    }, []);

    return (
        <>
            <Box 
                component="section"
                sx={{ 
                    bgcolor: '#f5f5f5', 
                    width: 320,
                    height: 460, 
                    margin: '5% auto',
                    padding: '0 3%',
                }} 
            >
                <Box 
                    component="section"
                    sx={{  
                        width: '100%',
                        height: 120, 
                    }} 
                >
                    <img src={logo} alt={'Advanced Vendas'} loading="lazy" style={{ width: '100%', height: '100%' }}/>
                </Box>
                <Box 
                    component="section"
                    sx={{  
                        width: '100%',
                        height: 340,
                    }} 
                >
                    <form 
                        style={{ 
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >

                        <h3 style={{ fontSize: 24, fontWeight: 'bold', marginBottom: 20, textAlign: 'center' }}>
                            LOGIN
                        </h3>

                        <Grid container rowSpacing={2}>

                            <Grid size={12}>
                                <TextField 
                                    id="outlined-basic" 
                                    label="Login usuário" 
                                    value={userLogin.email} 
                                    onChange={(e) => setUserLogin((prev) => ({...prev, email: e.target.value.slice(0,100)}))}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>

                            <Grid size={12}>
                                <TextField 
                                    id="outlined-basic" 
                                    label="Senha" 
                                    variant="outlined" 
                                    onChange={(e) => setUserLogin((prev) => ({...prev, senha: e.target.value.slice(0,60)}))}
                                    type="password"
                                    autoComplete="new-password"
                                    fullWidth
                                />
                            </Grid>

                            <Button 
                                component={'button'} 
                                onClick={handleSubmitLogin} 
                                variant="contained" 
                                size="large" 
                                fullWidth 
                                sx={{ 
                                    marginBottom: 0 
                                }}
                            > 
                                Entrar
                            </Button>

                        </Grid>
                    </form>
                </Box>
            </Box>
        </>
    );
}

export default Login;